import useMediaQuery from 'hooks/useMediaQuery'
import Button from 'new-components/Button'
import { useHistory } from 'react-router'
import { MOBILE_WIDTH } from 'utils/constants'
import * as Styles from './styles'

export interface BannerHealthProps {
  backgroundImage?: string
}

export default function BannerHealth({ backgroundImage }: BannerHealthProps) {
  const history = useHistory()
  const isMobile = useMediaQuery(MOBILE_WIDTH)

  const redirectLink = (link = 'https://atendimento.cannect.life/atendimento-cannect') => {
    window.open(link, '_blank', 'noopener')
  }
  return (
    <Styles.Wrapper backgroundImage={backgroundImage}>
      <Styles.Content>
        <Styles.TitleBanner>
          <span>Faça parte</span> da nossa <span>comunidade científica</span>
        </Styles.TitleBanner>
        <Styles.TextBanner>
          Acesso a centenas de artigos científicos e a uma rede de profissionais da saúde conectados para explorar e
          discutir o uso de cannabis medicinal, rede exclusiva para profissionais que realizaram onboarding.
        </Styles.TextBanner>
        <Styles.ActionsContent>
          <Button height={isMobile ? 70 : 45} background="green" onClick={() => history.push('/cadastro')}>
            Cadastre-se
          </Button>
          <Button
            height={isMobile ? 70 : 45}
            background="green"
            isOutlined
            onClick={() =>
              redirectLink(
                'https://api.whatsapp.com/send/?phone=5511914396241&text=Ol%C3%A1%2C+gostaria+de+saber+mais+sobre+a+Cannect+%21+-+Inicie+a+conversa+para+ser+atendido&type=phone_number&app_absent=0'
              )
            }>
            Agende seu bate papo de Boas Vindas
          </Button>
        </Styles.ActionsContent>
      </Styles.Content>
    </Styles.Wrapper>
  )
}
